import { combineReducers } from 'redux';

import cannedResponses from './cannedResponses/slice';
import ingredientsSearch from './ingredientsSearch/slice';
import inquiryEntryDetails from './inquiryEntryDetails/slice';
import inquiryList from './inquiryList/slice';
import adminNewMedication from './newMedication/slice';
import newSupplement from './newSupplement/slice';
import supplementSearch from './supplementSearch/slice';
import supplementSendInquiry from './supplementSendInquiry/slice';

const adminInquiriesReducer = combineReducers({
  cannedResponses,
  ingredientsSearch,
  inquiryList,
  newSupplement,
  inquiryEntryDetails,
  supplementSearch,
  supplementSendInquiry,
  adminNewMedication,
});

export default adminInquiriesReducer;
